import { createReducer, INITIAL_STATE } from '../../shared/redux';

export const INTEGRATE_PLATFORM_IF_NEEDED = '@integrations/INTEGRATE_PLATFORM_IF_NEEDED';
export const REQUEST_INTEGRATION = '@integrations/REQUEST_INTEGRATION';
export const RETRIEVE_INTEGRATION_PLATFORM_INFO_IF_NEEDED = '@integrations/RETRIEVE_INTEGRATION_PLATFORM_INFO_IF_NEEDED';
export const REQUEST_INTEGRATION_PLATFORM_INFO = '@integrations/REQUEST_INTEGRATION_PLATFORM_INFO';
export const SET_INTEGRATION_PROPERTIES = '@integrations/SET_INTEGRATION_PROPERTIES';

export type State = {
    platform: {
        name: string,
        id: string,
    }
}

export const getIntegrationPlatform = state => state
    .integrations.integrationsProperties.platform;

export const retrieveIntegrationPlatformInfoIfNeeded = () => ({
    type: RETRIEVE_INTEGRATION_PLATFORM_INFO_IF_NEEDED,
    payload: {},
});

export const requestIntegrationPlatformInfo = () => ({
    type: REQUEST_INTEGRATION_PLATFORM_INFO,
    payload: {},
});

export const integratePlatformIfNeeded = () => ({
    type: INTEGRATE_PLATFORM_IF_NEEDED,
    payload: {},
});

export const requestIntegration = () => ({
    type: REQUEST_INTEGRATION,
    payload: {},
});

export const setIntegrationProperties = (platform: {name: string, id: string}) => ({
    type: SET_INTEGRATION_PROPERTIES,
    payload: platform,
});

const initialState: State = {
    platform: {
        name: null,
        id: null,
    },
};

export const integrationsPropertiesReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [SET_INTEGRATION_PROPERTIES]: (state, action) => ({
        ...state,
        platform: action.payload,
    }),
});
